// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-7BL","colBig":"styles_colBig___PzBU","colSmall":"styles_colSmall__14dOS","shopifyNameWrapper":"styles_shopifyNameWrapper__dkZe0"};